import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Row, Col, ButtonGroup, Button, Card, CardBody, CardTitle, CardText, CardImg } from 'reactstrap';
import { Link } from "react-router-dom";
import { PageTitle, ApplicationDetails, CopyButton, Loader } from '../../../components';
import moment from 'moment';

import { Utils } from '../../../services/';
import { loadUser, setMessagesUsersIds, spoof } from '../../../redux';

import user_avatar from '../../../assets/images/user_avatar.jpg';

const UserShow = props => {
    const { t, i18n } = useTranslation();
    const history     = useHistory();
    const dispatch    = useDispatch();

    const { user }     = useSelector(state => state.users);
    const { setting }  = useSelector(state => state.settings);
    const current_user = useSelector(state => state.auth.user);

    const { isMobile, isTablet } = useSelector(state => state.ui);

    const { userId } = props.match.params;
    useEffect(() => {
        dispatch(loadUser(userId));
    }, []);

    const current_lng = (i18n.language) ? i18n.language.substr(0, 2) : null;

    const sendEmail = () => {
        dispatch(setMessagesUsersIds([ user.id ]));
        history.push('/messages');
    };

    const spoofUser = () => {
        dispatch(spoof(user.id));
    };

    if (!current_user || !user || (user.id !== userId))
        return <Loader />;

    const title = current_user.id === user.id ?
        <span>{t('users.my_profile')}</span>
        :
        <span>
            {t('users.user', {count: 1})}
            <small> | { user.firstname } { user.lastname }</small>
        </span>

    const actions =
    <div>
        <ButtonGroup>
            <Button tag={Link} to="/users" color="warning" size="sm">
                <i className="fa fa-arrow-left"></i>&nbsp;{t('common.back')}
            </Button>
            {user &&
                <Button tag={Link} to={ `/users/edit/${ user.id }` } color="info" size="sm">
                    <i className="fa fa-edit"></i>&nbsp;{t('common.edit')}
                </Button>
            }
        </ButtonGroup>
    </div>

    return (
        <div className="UserShow">
            <PageTitle icon="users" title={ title } actions={ actions } />
            {user &&
                <Row>
                    <Col xs={12} lg={3}>
                        <div style={{ maxWidth: '350px', margin: '0 auto 20px auto' }}>
                            <Card>
                                <CardImg top src={user.avatar || user_avatar} alt="Card image cap" />
                                {current_user.can('create', 'messages') && (current_user.id !== user.id) &&
                                    <Button onClick={ sendEmail } color="primary" className="mt-1">
                                        <i className="fa fa-envelope" />&nbsp;
                                        { t('tickets.batch.send_email') }
                                    </Button>
                                }
                                {current_user.can('spoof', 'users') && current_user.id !== user.id &&
                                    <Button onClick={ spoofUser } color="warning" className="mt-1">
                                        <i className="fa fa-user-secret" />&nbsp;
                                        { t('users.spoof') }
                                    </Button>
                                }
                            </Card>
                        </div>
                        {user?.tickets?.length > 0 && (
                        <div className="mb-3">
                            <Card>
                                <CardBody>
                                    <div className="wrapper-0">
                                        <CardTitle>
                                            <i className="fa fa-tags"></i>&nbsp;
                                            {t('users.tickets')}
                                        </CardTitle>
                                        <CardText tag="div">
                                            <div className="d-flex flex-column gap-2">
                                                {user.tickets?.map(ticket => (
                                                    <div key={ticket._id} className="w-100">
                                                        <Card className="">
                                                            <CardBody>
                                                                <CardText tag="div">
                                                                    <h4>
                                                                        { Utils.localized_or_fallback(ticket.type.name, i18n.lang) }
                                                                    </h4>
                                                                    <div className="d-flex flex-column gap-1 justify-start">
                                                                        {ticket.vdr_auth_serial && (
                                                                            <CopyButton
                                                                                size="md"
                                                                                color="info"
                                                                                title={ 'TicketID: ' + ticket.vdr_auth_serial + '-' + ticket.vdr_auth_key }
                                                                                textToCopy={ ticket.vdr_auth_serial + '-' + ticket.vdr_auth_key }
                                                                                className="btn-block"
                                                                            />
                                                                        )}
                                                                        {ticket.status === "activated" && (
                                                                            <Button
                                                                                size="xs"
                                                                                color="primary"
                                                                                href={`${setting?.eshop?.uri}/ticket/pdf/?uuid=${ticket._id}`}
                                                                                target="_blank"
                                                                                className="btn-block"
                                                                            >
                                                                                <i className="fa fa-file-pdf-o"></i>&nbsp;
                                                                                { t('common.download') }
                                                                            </Button>
                                                                        )}
                                                                        <Button
                                                                            size="xs"
                                                                            color="primary"
                                                                            href={`${setting?.eshop?.uri}/ticket/view/?uuid=${ticket._id}`}
                                                                            target="_blank"
                                                                            className="btn-block"
                                                                        >
                                                                            <i className="fa fa-external-link"></i>&nbsp;
                                                                            { t('common.see') }
                                                                        </Button>
                                                                    </div>
                                                                </CardText>
                                                            </CardBody>
                                                        </Card>
                                                    </div>
                                                ))}
                                            </div>
                                        </CardText>
                                    </div>
                                </CardBody>
                            </Card>
                        </div>
                        )}
                    </Col>
                    <Col xs={12} lg={9}>
                        <Row>
                            <Col sm={12} lg={6} className="mb-3">
                                <Card>
                                    <CardBody>
                                        <CardTitle>
                                            <i className="fa fa-user-circle"></i>&nbsp;
                                            {t('users.profile')}
                                        </CardTitle>
                                        <CardText tag="div">
                                            <div><b>{t('users.firstname')}</b>: { user.firstname }</div>
                                            <div><b>{t('users.lastname')}</b>: { user.lastname }</div>
                                            <div><b>{t('users.role')}</b>: { Utils.roles(user.role).label }</div>
                                        </CardText>
                                    </CardBody>
                                </Card>
                            </Col>
                            <Col sm={12} lg={6} className="mb-3">
                                <Card>
                                    <CardBody>
                                        <CardTitle>
                                            <i className="fa fa-envelope"></i>&nbsp;
                                            {t('users.contact')}
                                        </CardTitle>
                                        <CardText tag="div">
                                            <div><b>{t('users.email')}</b>: { user.email }</div>
                                            <div><b>{t('users.fix_phone')}</b> : { user.fix_phone }</div>
                                            <div><b>{t('users.mobile_phone')}</b> : { user.mobile_phone }</div>
                                            <div><b>{t('users.pro_phone')}</b> : { user.pro_phone }</div>
                                            <div><b>{t('users.fax')}</b> : { user.fax }</div>
                                        </CardText>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                        <Row>
                            <Col sm={12} lg={6} className="mb-3">
                                <Card>
                                    <CardBody>
                                        <CardTitle>
                                            <i className="fa fa-address-card"></i>&nbsp;
                                            {t('users.address')}
                                        </CardTitle>
                                        <CardText tag="div">
                                            <div>{ user.address }</div>
                                            <div>{ user.zip } {user.city }</div>
                                            <div>{ user.country }</div>
                                        </CardText>
                                    </CardBody>
                                </Card>
                            </Col>
                            <Col sm={12} lg={6} className="mb-3">
                                <Card>
                                    <CardBody>
                                        <CardTitle>
                                            <i className="fa fa-th-list"></i>&nbsp;
                                            {t('users.other_informations')}
                                        </CardTitle>
                                        <CardText tag="div">
                                            <div><b>{t('users.birthday')}</b>: { user.birthday ? moment(user.birthday).format('LL') : '' }</div>
                                            <div><b>{t('users.avs')}</b>: { user.avs }</div>
                                            <div><b>{t('users.bank')}</b>: { user.bank }</div>
                                            <div><b>{t('users.bic')}</b>: { user.bic }</div>
                                            <div><b>{t('users.iban')}</b>: { user.iban }</div>
                                        </CardText>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                        { current_user?.tkt_instance?.hasModule(Utils.MODULE_TEAM) &&
                          (user?.activities?.length > 0 ||  user?.applications?.length > 0) &&
                            <Row>
                                <Col sm={12} lg={12}>
                                    <Card>
                                        <CardBody>
                                            {user?.activities?.length > 0 &&
                                                <>
                                                    <CardTitle><i className="fa fa-id-badge"></i>&nbsp;
                                                    {t("users.activities")}
                                                    </CardTitle>
                                                    <CardText tag="div" className="mb-5">
                                                        { user.activities && user.activities.map(activity => <div key={activity.id} className="badge badge-light mr-2"> {activity.name[current_lng]}</div>) }
                                                    </CardText>
                                                </>
                                            }
                                            { user?.applications?.length > 0 &&
                                                <>
                                                    <CardTitle><i className="fa fa-id-badge"></i>&nbsp;{t("users.application")}</CardTitle>
                                                    <CardText tag="div">
                                                        { user?.applications?.map(application => (
                                                            <CardText key={ application.id } tag="div">
                                                                <ApplicationDetails application={ application } />
                                                            </CardText>
                                                        ))}
                                                        </CardText>
                                                </>
                                            }
                                        </CardBody>
                                    </Card>
                                </Col>
                            </Row>
                        }
                        {current_user?.isSuperAdmin() && (
                            <Row>
                                <Col sm={12} lg={6}>
                                    <Card>
                                        <CardBody>
                                            <CardTitle>
                                                <i className="fa fa-ticket"></i>&nbsp;
                                                {t('common.tktInstance', {count:1})}
                                            </CardTitle>
                                            <CardText tag="div">
                                                { user.tkt_instance &&
                                                    user.tkt_instance.name
                                                }
                                            </CardText>
                                        </CardBody>
                                    </Card>
                                </Col>
                            </Row>
                        )}
                    </Col>
                </Row>
            }
        </div>
    );
}

export default UserShow;
